import { API_END_POINTS } from './networks/apiEndPoints';
import api from './networks/api';

export const getRegionCities = async (payload) => {
    try {
        const response = await api.get(API_END_POINTS.GET_REGIONS, {
            params: payload  
        });
        const data = response.data;

        if (data.errorCode === 200) {
            if (!data.responseData) {
                throw new Error('No template data returned');
            }
            return data.responseData;
        } else {
            throw new Error(data.errorMessage || 'Failed to fetch slot config day region');
        }
    } catch (error) {
        console.error('Error fetching slot config day region:', error);
        throw error;
    }
};
